import React, { useState } from "react";

const JobCardForm = () => {
  const [formData, setFormData] = useState({ name: "", city: "", phone: "" });
  const [selectedItem, setSelectedItem] = useState("");
  const [items, setItems] = useState([]);

  const availableItems = ["Motor", "Pump", "Shaft", "Impeller", "Bearing"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const addItem = () => {
    if (selectedItem && !items.includes(selectedItem)) {
      setItems((prev) => [...prev, selectedItem]);
      setSelectedItem("");
    }
  };

  const removeItem = (item) => {
    setItems((prev) => prev.filter((i) => i !== item));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const jobCardData = { ...formData, items };
    console.log("Job Card Submitted:", jobCardData);
  };

  return (
    <div className="max-w-3xl mx-auto mt-8 p-4 md:p-10 bg-white shadow rounded">
      <h2 className="text-lg font-bold mb-4 text-center">Create Job Card</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Row of 3 inputs */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <input
            type="text"
            name="name"
            placeholder="Name"
            className="border p-2 rounded w-full"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            className="border p-2 rounded w-full"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="city"
            placeholder="City"
            className="border p-2 rounded w-full"
            value={formData.city}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Item Dropdown and Add */}
        <div className="flex gap-3">
          <select
            className="border p-2 rounded flex-1"
            value={selectedItem}
            onChange={(e) => setSelectedItem(e.target.value)}
          >
            <option value="">-- Select Item --</option>
            {availableItems.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
          <button
            type="button"
            onClick={addItem}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Add
          </button>
        </div>

        {/* Item List */}
        {items.length > 0 && (
          <div>
            <h4 className="font-medium mb-2 mt-2">Items Added:</h4>
            <ul className="space-y-1">
              {items.map((item, index) => (
                <li
                  key={index}
                  className="flex justify-between items-center bg-gray-100 px-3 py-1 rounded"
                >
                  <span>{item}</span>
                  <button
                    type="button"
                    onClick={() => removeItem(item)}
                    className="text-red-500 text-sm"
                  >
                    Remove
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}

        <button
          type="submit"
          className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"
        >
          Submit Job Card
        </button>
      </form>
    </div>
  );
};

export default JobCardForm;
